import { gql } from '@apollo/client';

export const ADMIN_SUPPORT_MESSAGES = gql`
  query ADMIN_SUPPORT_MESSAGES($take: Int, $skip: Int) {
    adminSupportMessages(take: $take, skip: $skip) {
      id
      createdAt
      message
      communicationMethod
      communicationValue
      userId
    }
    adminSupportMessagesCount
  }
`;
